import styled from 'styled-components'

export const Container = styled.div`
  max-height: 40vh;
  overflow-y: auto;
  margin: 0 ${props => props.theme.spacing.sp16} ${props => props.theme.spacing.sp12};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const Head = styled.thead`
  position: sticky;
  top: 0;
  background-color: ${props => props.theme.colors.background.secondary};
`

export const HeaderCell = styled.th`
  text-align: left;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
`

export const BodyRow = styled.tr`
  &:nth-child(even) {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`

export const Cell = styled.td`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
`
